import { VStack } from "@whoosh/design-system/src/components/primitive";

import { UnknownGuestCounter } from "./UnknownGuestCounter";

export const GuestListHeader = ({
  onAddUnknownGuest,
  onRemoveUnknownGuest,
  capacityOnBooking,
  membersCanAddUnknownGuests,
}: {
  onAddUnknownGuest: () => void;
  onRemoveUnknownGuest: () => void;
  capacityOnBooking: number;
  membersCanAddUnknownGuests: boolean;
}) => {
  return (
    <VStack>
      <UnknownGuestCounter
        onAddUnknownGuest={onAddUnknownGuest}
        onRemoveUnknownGuest={onRemoveUnknownGuest}
        capacityOnBooking={capacityOnBooking}
        membersCanAddUnknownGuests={membersCanAddUnknownGuests}
      />
    </VStack>
  );
};
